import { upsellingModal } from '@/shared/components/UpsellingModal';

/**
 * AI 빌더 사용량 소진 CTA의 기본 동작 — 기존 paywall(UpsellingModal)을 오버레이로 연다.
 * 새 탭/페이지 이동 없이 채팅·에디터 컨텍스트를 유지한 채 모달만 띄우고, 실제 요금제
 * 이동은 모달 내부 CTA를 사용자가 직접 눌렀을 때만 발생한다.
 */
export const openAiBuilderPaywallModal = () => {
  upsellingModal.open({
    initialPlanType: 'PRO',
    from: 'aiBuilder',
  });
};
